export const meta: BlockMeta = {
  title: "Column",
  description: "Break content up into columns",
  keywords: ["columns"],
  icon: "format-aside",
  category: "layouts",
}

import { PanelBody, RadioControl } from "@wordpress/components"
import clsx from "clsx"
import { defineBlock, EditableText, InnerBlocks, InspectorControls, useInlineEditableValue } from "eddev/blocks"
import { useState } from "react"

export default defineBlock("layout/column", (props) => {
  const [layout, setLayout] = useInlineEditableValue("layout", "small")
  return (
    <div className={clsx(`column-${layout}`, env.admin && "min-h-10")}>
      {env.admin && (
        <InspectorControls>
          <PanelBody title="Layout">
            <RadioControl
              label="Columns"
              selected={layout}
              options={[
                { label: "Single", value: "small" },
                { label: "Medium", value: "medium" },
                { label: "Large", value: "large" },
              ]}
              onChange={setLayout}
            />
          </PanelBody>
        </InspectorControls>
      )}
      <InnerBlocks
        allowedBlocks={["content"]}
        template={[
          ["core/heading", { level: 3, className: "is-style-small", content: "Morbi leo risus" }],
          [
            "core/paragraph",
            {
              content:
                "Curabitur blandit tempus porttitor. Maecenas faucibus mollis interdum. Maecenas sed diam eget risus varius blandit sit amet non magna.",
            },
          ],
        ]}
      />
    </div>
  )
})
